<div class="extra-info">
  <div *ngFor="let info of infoText" class="info">
    <span class="material-icons">check</span><span class="innertext" [innerHtml]="info?.text"></span>
  </div>
</div>